// Sort object keys recursively so semantically-equivalent JSON renders the
// same way on both sides of the diff (key reordering shouldn't show as a
// change).
const sortKeysDeep = (value: unknown): unknown => {
  if (Array.isArray(value)) {
    return value.map(sortKeysDeep);
  }
  if (value !== null && typeof value === 'object') {
    const entries = Object.entries(value as Record<string, unknown>).sort(
      ([a], [b]) => a.localeCompare(b)
    );
    return Object.fromEntries(entries.map(([k, v]) => [k, sortKeysDeep(v)]));
  }
  return value;
};

export const formatJson = (value: unknown) =>
  JSON.stringify(sortKeysDeep(value), null, 2);

// Compares equal for two values that differ only in key order, which a value
// that has crossed the API cannot be assumed to keep: an object stored as a
// free-form spec comes back with its keys sorted, whatever order it was sent in.
export const stableStringify = (value: unknown) =>
  JSON.stringify(sortKeysDeep(value));

export const isRecord = (value: unknown): value is Record<string, unknown> =>
  value !== null && typeof value === 'object' && !Array.isArray(value);
